module.exports = __webpack_public_path__ + "static/rcc-orr-graph-desktop-5366b906afc29e7afb618854524be51f.png";